module.exports = __webpack_public_path__ + "static/media/react.d101c08d.png";